// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountStatusDto } from './IAccountStatusDto';
import {
    IAccountStatusDtoFromJSON,
    IAccountStatusDtoFromJSONTyped,
    IAccountStatusDtoToJSON,
    IAccountStatusDtoToJSONTyped,
} from './IAccountStatusDto';

/**
 * 
 * @export
 * @interface IEncryptedAccountDto
 */
export interface IEncryptedAccountDto {
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    number_length?: number;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    on_deposit_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    live_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    parent_account_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IEncryptedAccountDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEncryptedAccountDto
     */
    modified_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEncryptedAccountDto
     */
    leaf_node?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    routing_transit_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    account_type?: IEncryptedAccountDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    account_category?: IEncryptedAccountDtoAccountCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IEncryptedAccountDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    account_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IEncryptedAccountDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {Set<IAccountStatusDto>}
     * @memberof IEncryptedAccountDto
     */
    account_statuses?: Set<IAccountStatusDto>;
}

/**
* @export
* @enum {string}
*/
export enum IEncryptedAccountDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IEncryptedAccountDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IEncryptedAccountDto interface.
 */
export function instanceOfIEncryptedAccountDto(value: object): value is IEncryptedAccountDto {
    return true;
}

export function IEncryptedAccountDtoFromJSON(json: any): IEncryptedAccountDto {
    return IEncryptedAccountDtoFromJSONTyped(json, false);
}

export function IEncryptedAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEncryptedAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'number_length': json['number_length'] == null ? undefined : json['number_length'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'on_deposit_balance': json['on_deposit_balance'] == null ? undefined : json['on_deposit_balance'],
        'live_balance': json['live_balance'] == null ? undefined : json['live_balance'],
        'parent_account_id': json['parent_account_id'] == null ? undefined : json['parent_account_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'modified_at': json['modified_at'] == null ? undefined : (new Date(json['modified_at'])),
        'leaf_node': json['leaf_node'] == null ? undefined : json['leaf_node'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'account_path': json['account_path'] == null ? undefined : json['account_path'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'account_statuses': json['account_statuses'] == null ? undefined : (new Set((json['account_statuses'] as Array<any>).map(IAccountStatusDtoFromJSON))),
    };
}

export function IEncryptedAccountDtoToJSON(json: any): IEncryptedAccountDto {
    return IEncryptedAccountDtoToJSONTyped(json, false);
}

export function IEncryptedAccountDtoToJSONTyped(value?: IEncryptedAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'number_length': value['number_length'],
        'available_balance': value['available_balance'],
        'on_deposit_balance': value['on_deposit_balance'],
        'live_balance': value['live_balance'],
        'parent_account_id': value['parent_account_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'modified_at': value['modified_at'] == null ? undefined : ((value['modified_at']).toISOString()),
        'leaf_node': value['leaf_node'],
        'routing_transit_number': value['routing_transit_number'],
        'account_type': value['account_type'],
        'account_category': value['account_category'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'employee_id': value['employee_id'],
        'external_identifier': value['external_identifier'],
        'account_path': value['account_path'],
        'account_number_last4': value['account_number_last4'],
        'account_statuses': value['account_statuses'] == null ? undefined : (Array.from(value['account_statuses'] as Set<any>).map(IAccountStatusDtoToJSON)),
    };
}

